/* Rquiere de mixin.js */

var lot = {
	data () {
		return {
			dateFromLots: '2020-07-15',
			dateToLots: '2020-07-18',
			listLots: [],
			methodsLot: {
				delete: '/delete',
				get: 'lots',
				show: 'lot/',
			},
            objectLot: {
                exists: 0,
                id: 0,
                user_id: 0,
                user: {},
                entity_id: 0,
                entity: {},
                created_at: '',
                updated_at: '',
                churchs: []
            },
            paginationLots: [],
            qRowsLot: 25,
            searchLots: ''
		}
	},
	computed: {
	},
	filters: {
	},
	methods:{
        changeQRowsLot() {
            localStorage.setItem('qRowsLot', this.qRowsLot)
			this.changeQRowsLotLocal()
        },
		changeQRowsLotLocal() {
			console.log('changeQRowsLotLocal no desarrollado')
		},
        clearObjectLot() {
            this.objectLot.exists = 0
            this.objectLot.id = 0
            this.objectLot.user_id = 0
            this.objectLot.user = {}
            this.objectLot.entity_id = 0
            this.objectLot.entity = {}
            this.objectLot.created_at = ''
            this.objectLot.updated_at = ''
            this.objectLot.churchs = []
        },
        getAllLots(page = 1) {
            this.listLots = []
            this.paginationLots = []
			let parameters = '?search=' + this.searchLots + '&page=' + page + '&qRow=' + this.qRowsLot + '&fromDate=' + this.dateFromLots + '&toDate=' + this.dateToLots
            let url = this.apiBackend + this.methodsLot.get + parameters
            this.$emit('showLockScreen', 'Obteniendo lista de Lotes . . .')
			this.axiosActionIS(this.apiBackend + this.methodsLot.get + parameters, 'GET', 'getAllLotsResult')
        },
        getAllLotsResult(response) {
            if(response.data.success === true) {
                this.listLots = response.data.data
                this.paginationLots = response.data.paginate
            }
            this.getAllLotsResultLocal(response)
        },
        getAllLotsResultLocal(response) {
            console.log('getAllLotsResultLocal no desarrollado', response)
        },
		setLotInit() {
			this.qRowsLot = (localStorage.getItem('qRowsLot') === null) ? this.qRowsLot : localStorage.getItem('qRowsLot')
			this.dateFromLots = this.currentDate(-30)
			this.dateToLots = this.currentDate()
			this.setLotInitLocal()
		},
        setLotInitLocal() {
            console.log('setLotInitLocal no desarrollado')
        }
	},
};

export default lot;